import { Button, Modal } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DspStaleArea } from '../graphql/checkDataStaleByPlanningPool';

interface DataStaleModalProps {
    visible: boolean;
    onRefresh: () => void;
    parcelsStale?: boolean;
    dspStaleAreas?: DspStaleArea[];
    areaNameMap?: Record<number, string>;
    dspNameMap?: Record<number, string>;
}

const DataStaleModal: React.FC<DataStaleModalProps> = ({
    visible,
    onRefresh,
    parcelsStale,
    dspStaleAreas,
    areaNameMap = {},
    dspNameMap = {},
}) => {
    const { t } = useTranslation();
    const hasDspStale = (dspStaleAreas?.length ?? 0) > 0;

    return (
        <Modal
            open={visible}
            title={parcelsStale
                ? t('splitOrder.drawer.parcelsStaleTitle')
                : t('delivery.routes.message.republishConflictDataStaleTitle')
            }
            closable={false}
            maskClosable={false}
            footer={[
                <Button
                    key="refresh"
                    type="primary"
                    onClick={onRefresh}
                    style={parcelsStale ? { backgroundColor: '#6366f1', borderColor: '#6366f1' } : undefined}
                >
                    {t('delivery.routes.label.refresh')}
                </Button>,
            ]}
        >
            {parcelsStale && (
                <p style={{ color: '#fa8c16' }}>
                    {t('splitOrder.drawer.parcelsStaleDesc')}
                </p>
            )}
            {hasDspStale && (
                <div style={{ color: '#fa8c16' }}>
                    <p>{t('delivery.routes.message.dspStaleDesc')}</p>
                    <ul style={{ paddingLeft: 20 }}>
                        {dspStaleAreas!.map((item) => {
                            const areaName = areaNameMap[item.areaId] ?? `Area ${item.areaId}`;
                            const oldDsp = dspNameMap[item.expectedDspId] ?? `DSP ${item.expectedDspId}`;
                            const newDsp = item.actualDspId != null
                                ? (dspNameMap[item.actualDspId] ?? `DSP ${item.actualDspId}`)
                                : t('delivery.routes.message.dspRemoved');
                            return (
                                <li key={item.areaId}>
                                    {areaName}: {oldDsp} → {newDsp}
                                </li>
                            );
                        })}
                    </ul>
                </div>
            )}
        </Modal>
    );
};

export default DataStaleModal;
